<script>
export default {
  name: 'DismissButton',
  emits: ['click'],
  props: {
    size: { type: String, default: 'md' },
  },
  computed: {
    sizeClass() {
      return this.size ? `btn-${this.size}` : ''
    },
  },
}
</script>

<template lang="pug">
button.btn.btn-text(:class="sizeClass" @click="$emit('click', $event)" type="button")
  slot Dismiss
</template>
